"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var rc_textarea_1 = tslib_1.__importDefault(require("rc-textarea"));
var useMergedState_1 = tslib_1.__importDefault(require("rc-util/lib/hooks/useMergedState"));
var omit_1 = tslib_1.__importDefault(require("rc-util/lib/omit"));
var config_provider_1 = require("../config-provider");
var SizeContext_1 = tslib_1.__importDefault(require("../config-provider/SizeContext"));
var info_boundary_1 = tslib_1.__importDefault(require("../info-boundary"));
var byteLength_1 = require("../util/byteLength");
var ClearableLabeledInput_1 = tslib_1.__importDefault(require("./ClearableLabeledInput"));
var Input_1 = require("./Input");
var TextArea = (0, info_boundary_1.default)(React.forwardRef(function (_a, ref) {
    var _b, _c, _d;
    var customizePrefixCls = _a.prefixCls, _e = _a.bordered, bordered = _e === void 0 ? true : _e, _f = _a.showCount, showCount = _f === void 0 ? false : _f, maxLength = _a.maxLength, className = _a.className, style = _a.style, resize = _a.resize, customizeSize = _a.size, isChineseAsTwoBytes = _a.isChineseAsTwoBytes, props = tslib_1.__rest(_a, ["prefixCls", "bordered", "showCount", "maxLength", "className", "style", "resize", "size", "isChineseAsTwoBytes"]);
    var _g = React.useContext(config_provider_1.ConfigContext), getPrefixCls = _g.getPrefixCls, direction = _g.direction;
    var size = React.useContext(SizeContext_1.default);
    var innerRef = React.useRef(null);
    var clearableInputRef = React.useRef(null);
    var composingRef = React.useRef(false);
    var _h = tslib_1.__read((0, useMergedState_1.default)(props.defaultValue, {
        value: props.value,
    }), 2), value = _h[0], setValue = _h[1];
    React.useEffect(function () {
        if (resize && showCount) {
            console.warn('resize 存在的情况下，不支持 showCount. ');
        }
    }, [resize, showCount]);
    var prevValue = React.useRef(props.value);
    React.useEffect(function () {
        if (props.value !== undefined || prevValue.current !== props.value) {
            setValue(props.value);
            prevValue.current = props.value;
        }
    }, [props.value, prevValue.current]);
    var handleSetValue = function (val, callback) {
        if (props.value === undefined) {
            setValue(val);
            callback === null || callback === void 0 ? void 0 : callback();
        }
    };
    var handleChange = function (e) {
        var valStr = String(e.target.value || '');
        var valStrLength = isChineseAsTwoBytes ? (0, byteLength_1.byteLength)(valStr) : valStr.length;
        var overflowed = maxLength ? valStrLength > maxLength : false;
        if (!overflowed || composingRef.current) {
            handleSetValue(e.target.value);
            (0, Input_1.resolveOnChange)(innerRef.current, e, props.onChange);
        }
        if (overflowed && !composingRef.current) {
            var cuted = (0, byteLength_1.cutString)(String(e.target.value), maxLength, isChineseAsTwoBytes);
            handleSetValue(cuted);
            e.target.value = cuted;
            (0, Input_1.resolveOnChange)(innerRef.current, e, props.onChange);
        }
    };
    var handleCompositionStart = function (e) {
        var _a;
        (_a = props.onCompositionStart) === null || _a === void 0 ? void 0 : _a.call(props, e);
        composingRef.current = true;
    };
    var handleCompositionEnd = function (e) {
        var _a;
        (_a = props.onCompositionEnd) === null || _a === void 0 ? void 0 : _a.call(props, e);
        composingRef.current = false;
        handleChange(e);
    };
    var handleReset = function (e) {
        handleSetValue('', function () {
            var _a;
            (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        });
        (0, Input_1.resolveOnChange)(innerRef.current, e, props.onChange);
    };
    var prefixCls = getPrefixCls('input', customizePrefixCls);
    React.useImperativeHandle(ref, function () {
        var _a;
        return ({
            resizableTextArea: (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea,
            focus: function (option) {
                var _a, _b;
                (0, Input_1.triggerFocus)((_b = (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea) === null || _b === void 0 ? void 0 : _b.textArea, option);
            },
            blur: function () { var _a; return (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.blur(); },
        });
    });
    var textArea = (React.createElement(rc_textarea_1.default, tslib_1.__assign({}, (0, omit_1.default)(props, ['allowClear']), { maxLength: isChineseAsTwoBytes ? undefined : maxLength, className: (0, classnames_1.default)((_b = {},
            _b["".concat(prefixCls, "-borderless")] = !bordered,
            _b[className] = className,
            _b["".concat(prefixCls, "-sm")] = size === 'small' || customizeSize === 'small',
            _b["".concat(prefixCls, "-lg")] = size === 'large' || customizeSize === 'large',
            _b["".concat(prefixCls, "-resize")] = resize,
            _b)), style: showCount ? undefined : style, prefixCls: prefixCls, onChange: handleChange, onCompositionEnd: handleCompositionEnd, onCompositionStart: handleCompositionStart, ref: innerRef })));
    var val = (0, Input_1.fixControlledValue)(value);
    // // Max length value
    // const hasMaxLength = Number(maxLength) > 0;
    // // fix #27612 将value转为数组进行截取，解决 '😂'.length === 2 等emoji表情导致的截取乱码的问题
    // val = hasMaxLength ? [...val].slice(0, maxLength).join('') : val;
    // TextArea
    var textareaNode = (React.createElement(ClearableLabeledInput_1.default, tslib_1.__assign({}, props, { prefixCls: prefixCls, direction: direction, inputType: "text", value: val, element: textArea, handleReset: handleReset, ref: clearableInputRef, bordered: bordered, className: className })));
    // Only show text area wrapper when needed
    if (showCount && !resize) {
        var valLength = isChineseAsTwoBytes ? (0, byteLength_1.byteLength)(val) : val.length;
        var overflowed = maxLength ? valLength >= maxLength : false;
        textareaNode = (React.createElement("div", { className: (0, classnames_1.default)("".concat(prefixCls, "-textarea"), (_c = {},
                _c["".concat(prefixCls, "-textarea-rtl")] = direction === 'rtl',
                _c["".concat(prefixCls, "-textarea-show-count-disabled")] = props.disabled,
                _c), "".concat(prefixCls, "-textarea-show-count"), className), style: style },
            textareaNode,
            React.createElement("span", { className: (0, classnames_1.default)("".concat(prefixCls, "-length")) },
                React.createElement("span", { className: (0, classnames_1.default)("".concat(prefixCls, "-length-item"), (_d = {},
                        _d["".concat(prefixCls, "-length-none")] = valLength <= 0,
                        _d["".concat(prefixCls, "-length-cur")] = valLength > 0,
                        _d["".concat(prefixCls, "-length-over")] = overflowed,
                        _d)) }, valLength),
                React.createElement("span", { className: "".concat(prefixCls, "-length-item") },
                    " /",
                    maxLength))));
    }
    return textareaNode;
}));
exports.default = TextArea;
//# sourceMappingURL=TextArea.js.map